<template>
  <a-form>
  <a-skeleton />
  <a-skeleton />
  <a-skeleton />
  </a-form>
</template>

<script>
  export default {
    name: 'FormLoading',
    data() {
      return {

      }
    }
  }
</script>

<style scoped>

</style>